module.exports = __webpack_public_path__ + "img/transbanjarbakula-icon.0f1ebca3.png";